/**
 * Related Courses - Expandable tile interactions
 * Reuses same logic as front-page-hero but for related courses grid
 */

// Animation timing constants (matches SCSS variables)
const RELATED_ANIMATION_TIMINGS = {
    move: 400,      // $moveAT
    expand: 400,    // $expandAT
    delay: 50,      // $expandDelay
};

const RELATED_FULL_CLOSE_TIME = RELATED_ANIMATION_TIMINGS.move + RELATED_ANIMATION_TIMINGS.expand + RELATED_ANIMATION_TIMINGS.delay;

document.addEventListener('DOMContentLoaded', () => {
    const grid = document.querySelector('.related-courses-grid');
    if (!grid) return;

    const tiles = grid.querySelectorAll('.hero-tile');
    const courseTiles = grid.querySelectorAll('.hero-tile--course');

    if (!courseTiles.length) return;

    // Create tooltip element for desktop
    const tooltip = document.createElement('div');
    tooltip.className = 'hero-tile__tooltip';
    document.body.appendChild(tooltip);

    // Track mouse position for tooltip (desktop only)
    let currentHoveredTile = null;

    courseTiles.forEach(tile => {
        const video = tile.querySelector('.hero-tile__video');
        const poster = tile.querySelector('.hero-tile__poster');

        if (!video) return;

        // Hover to play video and hide poster + show tooltip (desktop only)
        tile.addEventListener('mouseenter', () => {
            if (!tile.classList.contains('s--active')) {
                video.play().catch(err => console.log('Video play failed:', err));
                if (poster) poster.style.opacity = '0';

                // Show tooltip with course title (desktop only)
                if (window.innerWidth >= 768) {
                    currentHoveredTile = tile;
                    const titleEl = tile.querySelector('.hero-tile__title');
                    if (titleEl) {
                        tooltip.textContent = titleEl.textContent;
                        tooltip.classList.add('is-visible');
                    }
                }
            }
        });

        // Stop video when hover ends (unless active) + hide tooltip
        tile.addEventListener('mouseleave', () => {
            if (!tile.classList.contains('s--active')) {
                video.pause();
                video.currentTime = 0;
                if (poster) poster.style.opacity = '1';

                // Hide tooltip
                currentHoveredTile = null;
                tooltip.classList.remove('is-visible');
            }
        });

        // Track mouse movement for tooltip positioning
        tile.addEventListener('mousemove', (e) => {
            if (currentHoveredTile === tile && window.innerWidth >= 768) {
                // Position tooltip with -10px offset (10px to the left of cursor)
                tooltip.style.left = (e.clientX - 10) + 'px';
                tooltip.style.top = e.clientY + 'px';
            }
        });

        // Click to expand
        tile.addEventListener('click', (e) => {
            // Don't toggle if clicking the CTA link
            if (e.target.closest('.hero-tile__cta')) {
                return;
            }

            // If already active, do nothing
            if (tile.classList.contains('s--active')) return;

            e.preventDefault();

            // Store the tile's current position and size before going absolute
            const rect = tile.getBoundingClientRect();
            const gridRect = grid.getBoundingClientRect();
            tile.dataset.originalLeft = rect.left - gridRect.left;
            tile.dataset.originalTop = rect.top - gridRect.top;
            tile.dataset.originalWidth = rect.width;
            tile.dataset.originalHeight = rect.height;

            // Mark grid as having active element
            grid.classList.add('s--el-active');

            // Remove active from all tiles and reset their videos
            tiles.forEach(t => {
                if (t.classList.contains('s--active')) {
                    const otherVideo = t.querySelector('.hero-tile__video');
                    const otherPoster = t.querySelector('.hero-tile__poster');
                    if (otherVideo) {
                        otherVideo.pause();
                        otherVideo.currentTime = 0;
                    }
                    if (otherPoster) otherPoster.style.opacity = '1';
                }
                t.classList.remove('s--active');
            });

            // Set initial position before animation
            tile.style.left = tile.dataset.originalLeft + 'px';
            tile.style.top = tile.dataset.originalTop + 'px';
            tile.style.width = tile.dataset.originalWidth + 'px';
            tile.style.height = tile.dataset.originalHeight + 'px';

            // Add active to clicked tile (triggers absolute positioning)
            tile.classList.add('s--active');

            // Force reflow then trigger expansion
            requestAnimationFrame(() => {
                tile.style.left = '0';
                tile.style.top = '0';
                tile.style.width = '100%';
                tile.style.height = '100%';
            });

            // Play video and hide poster
            video.play().catch(err => console.log('Video play failed:', err));
            if (poster) poster.style.opacity = '0';

            // Hide tooltip when expanding
            tooltip.classList.remove('is-visible');
            currentHoveredTile = null;
        });
    });

    // Function to close active tile with proper animation timing
    const closeTile = () => {
        const activeTile = grid.querySelector('.hero-tile.s--active');
        if (!activeTile) return;

        // Add closing class
        activeTile.classList.add('s--closing');

        // Animate back to original position
        activeTile.style.left = activeTile.dataset.originalLeft + 'px';
        activeTile.style.top = activeTile.dataset.originalTop + 'px';
        activeTile.style.width = activeTile.dataset.originalWidth + 'px';
        activeTile.style.height = activeTile.dataset.originalHeight + 'px';

        // Remove active class
        activeTile.classList.remove('s--active');

        // Reset video
        const video = activeTile.querySelector('.hero-tile__video');
        const poster = activeTile.querySelector('.hero-tile__poster');
        if (video) {
            video.pause();
            video.currentTime = 0;
        }
        if (poster) poster.style.opacity = '1';

        // After full close animation completes, fade in other tiles and clean up
        setTimeout(() => {
            grid.classList.remove('s--el-active');
            activeTile.classList.remove('s--closing');
            // Clear inline styles so it returns to grid flow
            activeTile.style.left = '';
            activeTile.style.top = '';
            activeTile.style.width = '';
            activeTile.style.height = '';
        }, RELATED_FULL_CLOSE_TIME);
    };

    // Close button click handler
    courseTiles.forEach(tile => {
        const closeBtn = tile.querySelector('.hero-tile__close');
        if (closeBtn) {
            closeBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                closeTile();
            });
        }
    });

    // Click outside to collapse
    document.addEventListener('click', (e) => {
        // If clicking outside the related courses grid
        if (!e.target.closest('.related-courses-grid') && grid.querySelector('.hero-tile.s--active')) {
            closeTile();
        }
    });
});